<div class="w-full" #pageContainer>
    <div class="bg-card shadow rounded-2xl m-4">
        <div class="flex justify-between p-5 px-8 bg-primary rounded-t-2xl ">
            <div class="text-3xl text-white"><b>
                    {{ wellName }}
                </b></div>
            <div class="self-center" style="color: #dbd3d3;font-size: medium">
                {{ isViewOnly ? 'View' : 'Edit' }} Application Tracking Record
            </div>
        </div>

        <div class="p-12">
            <form [formGroup]="mocForm">
                <div class="grid grid-cols-4 gap-x-8">
                    <mat-form-field class="col-span-2">
                        <mat-label>Field Name</mat-label>
                        <input matInput formControlName="fieldLongName" />
                    </mat-form-field>

                    <mat-form-field class="col-span-2">
                        <mat-label>Platform Name</mat-label>
                        <input matInput formControlName="platformLongName" />
                    </mat-form-field>

                    <mat-form-field class="col-span-2">
                        <mat-label>Well String Name</mat-label>
                        <input matInput formControlName="wellStringShortName" />
                    </mat-form-field>

                    <mat-form-field class="col-span-2">
                        <mat-label>Well Name</mat-label>
                        <input matInput formControlName="wellLongName" />
                    </mat-form-field>

                    <mat-form-field class="col-span-2">
                        <mat-label>String Indicator</mat-label>
                        <input matInput formControlName="stringIndicatorShortName" />
                    </mat-form-field>
                </div>

                <div class="divider my-6"></div>

                <div class="grid grid-cols-4 gap-x-8 mt-4">
                    <mat-form-field class="col-span-2">
                        <mat-label>Well Production Status</mat-label>
                        <input matInput formControlName="wellProductionStatus" />
                    </mat-form-field>

                    <mat-form-field class="col-span-2">
                        <mat-label>Reported Failure</mat-label>
                        <input matInput formControlName="problemReported" />
                    </mat-form-field>

                    <mat-form-field class="col-span-2">
                        <mat-label>Failure Date</mat-label>
                        <input matInput formControlName="failureDate" />
                    </mat-form-field>

                    <mat-form-field class="col-span-2">
                        <mat-label>Failure Equipment</mat-label>
                        <input matInput formControlName="failureEquipment" />
                    </mat-form-field>
          
                    <mat-form-field class="col-span-2">
                        <mat-label>Overdue Date</mat-label>
                        <input matInput formControlName="overdueDate" />
                    </mat-form-field>

                    <mat-form-field class="col-span-2">
                        <mat-label>Overdue Day</mat-label>
                        <input matInput formControlName="overdueDays" />
                    </mat-form-field>

                    <mat-form-field class="col-span-2">
                        <mat-label>Submission Date</mat-label>
                        <input matInput formControlName="submissionDate" />
                    </mat-form-field>

                    <div class="col-span-2 flex flex-col">
                        <mat-label>Submission Status</mat-label>
                        <span class="mt-2 w-48" style="font-size: medium;" [ngClass]="{
                            'successBadge': submissionStatus == 'Open',
                            'failedBadge': submissionStatus == 'Closed',
                        }">
                            {{ submissionStatus ?? "-" }}
                        </span>
                    </div>
                </div>

                <div class="divider my-6"></div>

                <div class="grid grid-cols-4 gap-x-8 mt-4">
                    <mat-form-field class="col-span-2">
                        <mat-label>Created Date</mat-label>
                        <input matInput formControlName="inputDate" />
                    </mat-form-field>

                    <mat-form-field class="col-span-2">
                        <mat-label>Created By</mat-label>
                        <input matInput formControlName="inputBy" />
                    </mat-form-field>

                    <mat-form-field class="col-span-2">
                        <mat-label>Updated Date</mat-label>
                        <input matInput formControlName="updateDate" />
                    </mat-form-field>
                </div>
            </form>
        </div>
    </div>
</div>


<div class="fixed bottom-0 right-0 p-4 bg-card w-full">
    <div class="flex justify-end">
        <button class="btn btn-primary mx-2" (click)="location.back()">
            Back
        </button>
    </div>
</div>